import React from "react";
import { Link } from "gatsby"

import ImageModule from "../../modules/image_module";
import { PageLinks } from "../../common/page-links";
import ContentModule from "../../modules/content_module";

import "./Box.scss";

const Box = (props) => {
    const BoxList = props.BoxList;

    const ImageRenderList = ({item, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.image_Transforms) {
            processedImages = item?.imagetransforms?.image_Transforms;
        }
        return (
          <ImageModule ImageSrc={item.image} title={item.name} altText={item.name} imagetransforms={processedImages} ggfx_results={item?.ggfx_results} renderer="srcSet" imagename={imagename} strapi_id={item.id} />                           
        )
    } 

    return (
        <React.Fragment>
            <div className="address-box">
                <div className="box">
                    <Link to={`/${PageLinks.branch_finder}/${BoxList.slug}/`}><ImageRenderList item={BoxList} imagename={"office.image.tile_image"} /></Link>
                </div>
                <div className="box-content">
                    <div className="top-info">
                        <Link to={`/${PageLinks.branch_finder}/${BoxList.slug}/`}>
                            {BoxList.name}
                            <i className="icon-right"></i>
                        </Link>
                    </div>
                   
                    {/* {BoxList?.address && <address><ContentModule Content={BoxList.address.replace(/\n/g,'<br />')} /></address>} */}
                    {BoxList?.address && <address>{BoxList.address}</address>}
                    
                </div>
                {(BoxList?.email || BoxList?.mobile) && 
                    <div className="contact">
                        {BoxList.email && <Link to={`/${PageLinks.branch_finder}/${BoxList.slug}/${PageLinks.branch_contact}/`} className="icon-wrap mail"><i className="icon-mail"></i> <span>Email</span></Link>}
                    
                        {BoxList.mobile && <a href={`tel:${BoxList.mobile}`} className="icon-wrap tel"><i className="icon-phone"></i> <span>{BoxList.mobile}</span></a>}
                        
                    </div>
                }
            </div>
        </React.Fragment>
    );
};
export default Box;
